import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AutoCompleteSearcherComponent } from './components/autocomplete.searcher/auto.complete.searcher.component';
import { CategoryResolver, CodeResolver, CompanyResolver, DocumentLibraryResolver, JobTypeResolver, PrioritiesResolver, UserResolver, ZoneResolver } from './resolvers';
import { CoreDataSearchers } from './searchers';
import { CoreDataContextService } from './services/core.data.context.service';
import { CoreDataActions } from './state/core.data.actions';
import { CoreDataEffects } from './state/core.data.effects';



@NgModule({
  imports: [CommonModule, ReactiveFormsModule, AutoCompleteModule, EffectsModule.forFeature([CoreDataEffects])],
  declarations: [AutoCompleteSearcherComponent]
})
export class CoreDataModule {
  public static forRoot(): ModuleWithProviders<CoreDataModule> {
    return {
      ngModule: CoreDataModule,
      providers: [
        CoreDataActions,
        CoreDataSearchers,
        CategoryResolver,
        CodeResolver,
        CompanyResolver,
        JobTypeResolver,
        PrioritiesResolver,
        UserResolver,
        ZoneResolver,
        CoreDataContextService,
        DocumentLibraryResolver
      ]
    };
  }
}
